import { useState } from 'react'
import NextImage from 'next/image'

import { Heading } from 'components/heading'
import { cn } from 'utils'
import { WelcomeSectionContainer } from 'components/welcome-section-container'

import styles from './welcome-section.module.css'

export interface CustomWelcomeSectionProps {
  title?: string
  image: string
  className?: string
  withBgSun?: boolean
  subtitle?: string
  altText?: string
}

export const CustomWelcomeSection: FCRC<CustomWelcomeSectionProps> = ({
  image,
  className,
  title,
  withBgSun = true,
  children,
  subtitle,
  altText,
}) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false)
  const onLoad = () => {
    setIsImageLoaded(true)
  }

  if (!title) return null
  return (
    <WelcomeSectionContainer
      withBgSun={withBgSun}
      classNameSection={styles.section}
      className={className}
    >
      <Heading theme="h1" className={styles.title}>
        {title}
      </Heading>
      <p className={styles.subtitle}>{subtitle}</p>
      {children}

      <picture className={styles.imageContainer}>
        <NextImage
          src={image}
          width={730}
          height={730}
          quality={90}
          onLoadingComplete={onLoad}
          alt={altText || title}
          className={cn(styles.image, isImageLoaded && styles.ready)}
        />
      </picture>
    </WelcomeSectionContainer>
  )
}
